/*
 * A&K 10.000
 * Author: Rouven Pajewski
 * Company: ActiView GmbH
 *
 * http://www.actiview.de
 */

import enquire from 'enquire-js';

$(document).ready(function() {
    var $window = $(window),
        $navMiddleBar = $('#nav-middle-bar');

    enquire.register("screen and (max-width:992px)", {
        match: function() {
            $('.toggle-level-01, .toggle-level-02').bind();
            $('.dropdown-slide').removeClass('show');

            $('.toggle-level-01').click(function(e) {
                e.preventDefault();
                e.stopPropagation();
                // Aktiviert das angeklickte Element
                $(this).closest('li').toggleClass('level-active');
                $(this).closest('ul').toggleClass('active-level-01');
            });

            $('.toggle-level-02').click(function(e) {
                e.preventDefault();
                e.stopPropagation();
                // Aktiviert das angeklickte Element
                $(this).closest('li').toggleClass('level-active');
                $(this).closest('ul').toggleClass('active-level-02');
                $(this).closest('.navbar-nav').toggleClass('active-level-02');
            });

            $('.navbar-toggler').click(function() {
                $('body').toggleClass('fixed');
            });
        },
        unmatch: function() {
            $('.navbar-nav').removeClass('active-level-01');
            $('.navbar-nav').removeClass('active-level-02');
            $('.dropdown-slide ').removeClass('level-active');
            $('.navbar-mobile-overlay').hide();
            $('#nav-middle-bar').removeClass('search-active');

            $('.toggle-level-01, .toggle-level-02').unbind();
        }
    });

    $('.search-toggle-btn').click(function() {
        if ($navMiddleBar.hasClass('search-active')) {
            $('#nav-middle-bar').removeClass('search-active');
        } else {
            $('#nav-middle-bar').addClass('search-active');
        }
    });

    $('.navbar-close').click(function(){
        $('.navbar-toggler').click();
    });
});
